@let ratingValue = rating();
@let statusValue = rating().status || status();
@let scaleValue = scale();

<div
  [class.at_required_level]="statusValue === SkillDetailsStatus.AtRequiredLevel"
  [class.above_required_level]="statusValue === SkillDetailsStatus.AboveRequiredLevel"
  [class.below_required_level]="statusValue === SkillDetailsStatus.BelowRequiredLevel"
  [class.not_evaluated]="statusValue === SkillDetailsStatus.NoEvaluated"
  [class.not_required_level]="statusValue === SkillDetailsStatus.NoRequiredLevel"
  class="skill-rating"
  layout
  layout-wrap
  layout-align-items-center
>
  @for (position of scaleValue; track position) {
    <div
      [class.filled]="position <= (ratingValue.ratedProficiencyPosition || 0)"
      [class.expected]="position === (ratingValue.expectedProficiencyPosition || 0)"
      [rtTooltip]="'app.interview.summary.skills_summary.expected_proficiency_tooltip' | translate"
      [rtTooltipEnabled]="position === (ratingValue.expectedProficiencyPosition || 0)"
      class="skill-leaf-container"
      layout
    >
      <span class="skill-leaf"></span>
    </div>
  }
</div>

<div layout>
  <span
    [rtTooltip]="ratingValue.ratedProficiencyName"
    [rtTooltipEnableWhenTruncated]="true"
    class="skill-proficiency-name"
    >{{ ratingValue.ratedProficiencyName }}</span
  >
</div>
